import Component from '../component';

export default class AutoSubmitInput extends Component {
  constructor(element) {
    super(...arguments);

    this.$input = $(element);

    this.$parentForm = $(this.$input.parents().find('.globalSearch-form')[0]);

    this.bindEvents();
  }

  bindEvents() {
    this.onStateChanged = this.onStateChanged.bind(this);

    this.$input.on('change', this.onStateChanged);
  }

  unbindEvents() {
    this.$input.off('change');
  }

  onStateChanged() {
    this.submitForm();
  }

  submitForm() {
    this.$parentForm.trigger('submit');
  }
}
